// React and Hooks
import React, { useEffect, useRef, useState } from "react";

// Date-related
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

// Styles and CSS
import "./PolygonCreation.css";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";

// MUI and Icons
import { GoLocation } from "react-icons/go";

// Bootstrap
import Modal from "react-bootstrap/Modal";

// Leaflet and Map-related
import L from "leaflet";
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  Polygon,
  GeoJSON,
  LayersControl,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import * as turf from "@turf/turf";
import toGeoJSON from "@mapbox/togeojson";

// Utilities and Services
import axios from "axios";
import JSZip from "jszip";
import AuthService from "../../../services/auth.service";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import UserService from "../../../services/user.service";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png",
});

function LeafletLab() {
  // State management for UI elements
  const [showSuccess, setShowSuccess] = useState(false);
  const [showSendcoop, setShowSendcoop] = useState(false);
  const [showSend, setShowSend] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showErroroperation, setShowErroroperation] = useState(false);
  const [showAgreement, setShowAgreement] = useState(false);
  const [showNoNight, setShowNoNight] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sideBarToggle, setSideBarToggle] = useState(false);
  const [chosenForm, setChosenForm] = useState(1);
  const [agreementPage, setAgreementPage] = useState(1);
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);

  // State management for date and time
  const presentTime = dayjs(new Date());
  // const desiredLimit = dayjs(new Date() + 1 * 24 * 60 * 60 * 1000);
  const desiredLimit = dayjs(new Date() - 1 * 24 * 60 * 60 * 1000);
  const [dayTimeStart, setDayTimeStart] = useState(
    dayjs(new Date()).add(3, "minute")
  );
  const [dayTimeEnd, setDayTimeEnd] = useState(
    dayjs(new Date(timeStringToInt(dayTimeStart) + 10800000))
  );

  // State management for drone and pilot related data
  const [chosenPilot, setChosenPilot] = useState("");
  const [chosenHeight, setChosenHeight] = useState(90);
  const [isTimeBeingSet, setIsTimeBeingSet] = useState(false);
  const [availablePilot, setAvailablePilot] = useState([]);
  const [availableDrone, setAvailableDrone] = useState([]);
  const [availableDroneID, setAvailableDroneID] = useState("");

  // State management for dropdowns and selections
  const [dropdown_id, setDropDown_ID] = useState();
  const [selectedOption, setSelectedOption] = useState([]);

  // State management for file operations
  const [filename, setFilename] = useState(undefined);
  const [readFileDone, setReadFileDone] = useState(false);
  const [fileHeight, setFileHeight] = useState([]);

  // State management for mapping and geographical data
  const [simplifiedKMLPosition, setSimplifiedKMLPosition] = useState([]);
  const [wrongFormat, setWrongFormat] = useState(false);
  const [polygonArray, setPolygonArray] = useState([]);
  const [layerArray, setLayerArray] = useState([]);
  const [tempArrayID, setTempArrayID] = useState([]);
  const [polygonToDelete, setPolygonToDelete] = useState([]);
  const [intersection, setIntersection] = useState(false);
  const [areaIntersection, setAreaIntersection] = useState("");
  const [mapposition, setMapPosition] = useState([
    13.101029105523143, 100.92994760607247,
  ]);
  const mapRef = useRef();

  // State management for other functionalities
  const [tempAvailablePurpose, setTempAvailablePurpose] = useState([]);
  const [availablePurpose, setAvailablePurpose] = useState([]);
  const [selectedPurpose, setSelectedPurpose] = useState([]);
  const [ninetyHeight, setNinetyHeight] = useState(false);
  const [cooperative, setCooperative] = useState(false);
  const [coopUnit, setCoopUnit] = useState("");
  const [searchCoop, setSearhCoop] = useState(false);
  const [numbercoopUnit, setNumberCoopUnit] = useState("");
  const [coopArea, setCoopArea] = useState([]);
  const [coopTime, setCoopTime] = useState(0, 0);
  const [isCoopFound, setIsCoopFound] = useState(false);
  const [searchcheck, setSearchcheck] = useState(0);
  const [estimatedInfo, setEstimatedInfo] = useState([]);
  const [isEstimateAble, setIsEstimatable] = useState(true);
  const [prohibitPolygon, setProhibitPolygon] = useState([]);
  const [allReservedArea, setAllReservedArea] = useState([]);
  const [timedReservedArea, setTimedReservedArea] = useState([]);
  const [thailandProvince, setThailandProvince] = useState();
  const [PDRArea, setPDRArea] = useState();
  const [bangkokPopulation, setBangkokPopulation] = useState();
  const [hospital, setHospital] = useState();
  const [govOffice, setGovOffice] = useState();
  const [thaiGov, setThaiGov] = useState();
  const [embassy, setEmbassy] = useState();
  const [policeDepartment, setPoliceDepartment] = useState();
  const [isEdited, setIsEdited] = useState([]);
  const [confirmSend, setConfirmSend] = useState(false);

  const deleteTimerRef = useRef(null);

  const agreementContent = [
    {
      text: "สถานที่ที่จะปฏิบัติการบิน: (คำอธิบายรายละเอียดของตำแหน่งที่ปฏิบัติการบิน หรือขอบเขตของพื้นทีปฏิบัติการอาจจะต้องจัดเตรียมซึ่งอาจระบุไว้ในพิกัดละติจูดและลองจิจูด)",
      status: "-",
    },
    {
      text: "วันและเวลาที่เสนอเพื่อปฏิบัติการบิน (สูงสุด 5 คืน ภายในหนึ่งเดือนตามปฏิทิน)",
      status: "-",
    },
    {
      text: "ระบบเพื่อความปลอดภัยในการบิน ได้แก่ ระบบบันทึกการบิน (Flight Log) และระบบรับรู้ทางภูมิศาสตร์(Geo-Awareness)",
      status: "-",
    },
    {
      text: "ไฟแสดงตำแหน่ง (Navigation Lighting) และควรติดตั้งระบบไฟป้องกันการชน (Strobe or Anti-CollisionLight)",
      status: "-",
    },
    {
      text: "สถานีภาคพื้น (Ground Station)ควบคุม (Remote Controller Software) จะต้องสามารถระบุตำแหน่งของอากาศยานที่เป็นปัจจุบันให้กับนักบินทราบได้หรือซอฟต์แวร์ของชุด",
      status: "-",
    },
    {
      text: "สถานีภาคพื้น (Ground Station)หรือซอฟต์แวร์ของชุดควบคุม (Remote Controller Software) จะต้องสามารถระบุตำแหน่งของอากาศยานที่เป็นปัจจุบันให้กับนักบินทราบได้",
      status: "-",
    },
    {
      text: "ระบบป้องกันการชนและการหลบหลีกสิ่งกีดขวาง",
      status: "-",
    },
    {
      text: "ชุดอุปกรณ์ด้านความปลอดภัย ได้แก่ ชุดสะท้อนแสงรองเท้านิรภัย สำหรับนักบิน บุคลากรและเจ้าหน้าที่ที่เกี่ยวข้องกับการปฏิบัติการบิน",
      status: "-",
    },
    {
      text: "นักบินมีความรู้เกี่ยวกับกฎหมาย กฎระเบียบ ที่เกี่ยวข้องกับอากาศยานซึ่งไม่มีนักบิน และมีความรู้ความชำนาญในการบังคับอากาศยานและใช้ระบบของอากาศยานที่ใช้ในการปฏิบัติการบิน",
      status: "-",
    },
    {
      text: "มีผู้ช่วยสังเกตการบิน (Visual Observer, VO) ซึ่งนักบินรับรองว่าเป็นผู้มีความสามารถปฏิบัติการบินดังกล่าว",
      status: "-",
    },
    {
      text: "มีการสื่อสารที่มีประสิทธิภาพระหว่างนักบิน และผู้ช่วยสังเกตการบินตลอดระยะเวลาในการปฏิบัติการบิน",
      status: "-",
    },
    {
      text: "มีการทำประกันภัยสำหรับความเสียหายอันเกิดแก่ร่างกาย ชีวิต ตลอดจนทรัพย์สินของบุคคลที่สามวงเงินประกันไม่ต่ำกว่าหนึ่งล้านบาทต่อครั้ง",
      status: "-",
    },
    {
      text: "นักบิน และ/หรือ ผู้ช่วยสังเกตการบิน สามารถมองเห็นห้วงอากาศรอบข้างได้ตลอดเวลาปฏิบัติการบิน",
      status: "-",
    },
    {
      text: `นักบินต้องรักษาการสื่อสารที่มีประสิทธิภาพกับผู้ช่วยสังเกตการบิน เพื่อให้ทราบตำแหน่ง ระดับความสูง ท่าทางการบิน 
      และตำแหน่งของอากาศยานอย่างต่อเนื่อง รวมถึงข้อมูลสิ่งกีดขวาง เพื่อหลีกเลี่ยงการชนกันเพื่อความปลอดภัยในการปฏิบัติการบิน`,
      status: "-",
    },
    {
      text: "ผู้ช่วยสังเกตการบินแต่ละคนจะต้องไม่สังเกตการอาากศยานมากกว่า 1 ลำหรือช่วยสนับสนุนนักบินมากกว่าหนึ่งคนในเวลาเดียวกัน และไม่ควรได้รับมอบหมายหน้าที่อื่นๆ พร้อมกัน",
      status: "-",
    },
    {
      text: `ทำการสำรวจพื้นที่ปฏิบัติการและประเมินด้านความปลอดภัย (Conduct site and Flight safety assessment)ในเวลากลางวัน 
      เพื่อให้ทราบสภาพสถานที่ และแนวทางที่เหมาะสมในการปฏิบัติการบินรวมถึงกรอกแบบฟอร์มการสำรวจพื้นที่และแบบฟอร์มที่เกี่ยวข้องให้ครบถ้วน`,
      status: "-",
    },
    {
      text: `จุดบินขึ้นและลง (รวมถึงจุดลงจอดฉุกเฉิน) จะต้องมี แสงสว่างเพียงพอเพื่อให้การมองเห็นที่ชัดเจน 
      เพื่อความปลอดภัยและการอํานวยความสะดวกในการขึ้นและลงของอากาศยาน และป้องกันบุคคลไม่เกี่ยวข้อง เข้ามาในพื้นที่บินขึ้นลง`,
      status: "-",
    },
    {
      text: `จุดบินขึ้นและลง (รวมถึงจุดลงจอดฉุกเฉิน) จะต้องมี แสงสว่างเพียงพอเพื่อให้การมองเห็นที่ชัดเจน 
      เพื่อความปลอดภัยและการอํานวยความสะดวกในการขึ้นและลงของอากาศยาน และป้องกันบุคคลไม่เกี่ยวข้อง เข้ามาในพื้นที่บินขึ้นลง`,
      status: "-",
    },
    {
      text: "นักบินจะต้องได้รับข้อมูลที่เกี่ยวข้อง ได้แก่ ทัศนวิสัย ภาคพื้นดิน ฐานเมฆ ความเร็วลม และปริมาณน้ําฝน ของพื้นที่ปฏิบัติการบินจากกรมอุตุนิยมวิทยา",
      status: "-",
    },
    {
      text: "ไม่ปฏิบัติการบินในพื้นที่หวงห้ามเฉพาะ พื้นที่หวงห้าม เด็ดขาด หรือพื้นที่อันตราย และไม่ทําการบรรทุกวัตถุอันตราย",
      status: "-",
    },
    {
      text: `ต้องปฏิบัติตามข้อกําหนดอื่น ได้แก่ \n
      1.)ปฏิบัติการบินในระยะสายตา \n
      2.)ใช้ระดับความสูงไม่เกิน 300 ฟุต \n
      3.)รักษาระยะห่างด้านข้างกับบุคคล ยานพาหนะ หรือ โครงสร้างที่ไม่เกี่ยวข้องใด ๆ \n
      4.)ไม่ปฏิบัติการบินบรรทุกคน หรือสัตว์ \n
      5.)ไม่ปฏิบัติการบินทิ้งสิ่งของจากอากาศยาน \n
      6.)ไม่ปฏิบัติการบินอากาศยานมากกว่า 1 ลํา ในเวลา เดียวกัน`,
      status: "-",
    },
    {
      text: "บริเวณภาคพื้นดิน สามารถมองเห็นได้ชัดเจน โดย นักบิน ผู้ช่วยสังเกตการบิน และ/หรือพนักงาน สนับสนุน เพื่อให้การบังคับและมองเห็น อากาศยานเป็นไปอย่างมีประสิทธิภาพ",
      status: "-",
    },
    {
      text: "ไม่ปฏิบัติการบินเข้าไปในเมฆ",
      status: "-",
    },
    {
      text: "นักบินต้องสามารถทราบความเร็วลม บริเวณพื้นผิว ของพื้นที่ที่จะปฏิบัติการบินและความเร็วลมไม่เกินกว่าที่บริษัทผู้ผลิตอากาศยานกําาหนด",
      status: "-",
    },
    {
      text: `นักบินจะต้องมีขั้นตอนปฏิบัติที่เหมาะสม และมีกลไก ป้องกันด้านความปลอดภัย (Fail-Safe Mechanism) สําหรับกรณีฉุกเฉินระหว่างการปฏิบัติการบิน 
      เช่นการสูญเสียค่าสั่งควบคุม (Loss of Command) และการ เชื่อมโยงการควบคุม (Control Link) การสูญเสียอุปก รณ์น้าทาง (Loss of Navigation Light)`,
      status: "-",
    },
    {
      text: "กรณีเกิดอุบัติเหตุ ซึ่งมีบุคคลบาดเจ็บหรือทรัพย์สินเกิด ความเสียหาย ให้แจ้งตํารวจ และรายงานฝ่ายมาตรฐานอากาศยานซึ่งไม่มีนักบิน ที่uas ur@caat.or.th โดยเร็วทั้งนี้ไม่เกิน 24 ชั่วโมงนับจากเกิดเหตุ",
      status: "-",
    },
    {
      text: `ผู้ได้รับอนุญาตจะต้องให้รายละเอียดเพิ่มเติม และ/หรือ ผลการสอบสวนภายใน 3 วัน 
      โดยเป็นลายลักษณ์ อักษรทางอีเมล์ที บอร ur@caat.or.th บันทึก เหตุการณ์ ทั้งหมดจะต้องได้รับเก็บการดูแลอย่างเหมาะสม`,
      status: "-",
    },
    {
      text: `ไฟแสดงตําแหน่ง (Navigation Lighting) ต้องเปิดอยู่ ตลอดเวลาในขณะปฏิบัติการบิน เพื่อให้นักบิน และ/หรือผู้ช่วยสังเกตการบินสามารถมองเห็นระบุ คําแหน่ง ทิศทาง ของอากาศยาน`,
      status: "-",
    },
    {
      text: `ก่อนขึ้นปฏิบัติการบิน อากาศยานจะต้องสามารถ เชื่อมต่อสัญญาณดาวเทียมได้ (Achieve a Positive Satellite Lock) อย่างน้อย 7 ดวง`,
      status: "-",
    },
    {
      text: `นักบินจะต้องมีขั้นตอนปฏิบัติที่เหมาะสม และมีกลไกป้องกันความไม่ปลอดภัย (Fail-Safe Mechanism) 
      สําหรับกรณีฉุกเฉินระหว่างการปฏิบัติการบิน เช่นการ สูญเสียค่าสั่งควบคุม (Loss of Command) และ เชื่อมต่อ (Control Link) การสูญเสียไฟนําทาง (Loss of Navigation Light)`,
      status: "-",
    },
    {
      text: `ซอฟต์แวร์ของชุดควบคุม (Remote Controller Software)จะต้องสามารถระบุตําแหน่งของอากาศยานที่เป็นปัจจุบันได้`,
      status: "-",
    },
    {
      text: `มีผู้ช่วยสังเกตการบิน (Visual Observer)`,
      status: "-",
    },
  ];

  const showMyLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (mapRef.current) {
            mapRef.current.flyTo(
              [position.coords.latitude, position.coords.longitude],
              17,
              {
                animate: true,
              }
            );
          }
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    }
    if (mapRef.current) {
      mapRef.current.flyTo([13.102617437258145, 100.88806223049966], 15, {
        animate: true,
      });
    }
  };

  const handleCreation = (e) => {
    const { layer } = e;
    setLayerArray((previous) => [...previous, layer]);

    let positions = [];

    if (layer instanceof L.Circle) {
      positions = calculateCircleMarkers(layer);
    } else if (layer instanceof L.Polygon) {
      positions = convertPolygonToCoordinates(layer);
    }

    if (positions.length) {
      updateArrays(layer, positions);
    }
  };

  const calculateCircleMarkers = (layer) => {
    const { lat, lng } = layer.getLatLng();
    const circleRadius = layer._mRadius;
    const numPoints = 36;
    const markerPositions = [];
    for (let i = 0; i < numPoints; i++) {
      const angleRad = ((2 * Math.PI) / numPoints) * i;

      const deltaX = circleRadius * Math.cos(angleRad);
      const deltaY = circleRadius * Math.sin(angleRad);

      const newLng = lng + deltaX / (111320 * Math.cos(lat * (Math.PI / 180)));
      const newLat = lat + deltaY / 110574;

      markerPositions.push([newLng, newLat]);
    }

    markerPositions.push(markerPositions[0]);
    return markerPositions;
  };

  const convertPolygonToCoordinates = (polygon) => {
    const latLngs = polygon.getLatLngs()[0];
    const coordinates = latLngs.map(({ lng, lat }) => [lng, lat]);
    coordinates.push(coordinates[0]);
    return coordinates;
  };

  const updateArrays = (layer, positions) => {
    setTempArrayID((previous) => [...previous, layer._leaflet_id]);
    setPolygonArray((previous) => [...previous, positions]);
  };

  function checkAllPolygon() {
    let intersectionCount = 0;
    let turfPolygonArray;
    // turfPolygonArray = polygonArray.map((polygon) => turf.polygon([polygon]));
    // console.log(turfPolygonArray)

    try {
      turfPolygonArray = polygonArray.map((polygon) => turf.polygon([polygon]));
      console.log(turfPolygonArray);
      if (polygonArray.length > 0) {
        for (let i = 0; i < turfPolygonArray.length; i++) {
          const drawnPolygonCoords = turfPolygonArray[i];
          let isIntersecting = false;

          for (let j = 0; j < turfPolygonArray.length; j++) {
            if (
              i !== j &&
              turf.booleanIntersects(turfPolygonArray[j], drawnPolygonCoords)
            ) {
              isIntersecting = true;
              intersectionCount++;
              if (chosenForm === 1) {
                layerArray[i].setStyle({
                  color: "red",
                  fillColor: "lightpink",
                });
              }
              break;
            }
          }

          if (!isIntersecting) {
            for (let k = 0; k < prohibitPolygon.length; k++) {
              if (
                (k < 92 || k > 97) &&
                turf.booleanIntersects(
                  turf.polygon([prohibitPolygon[k]]),
                  drawnPolygonCoords
                )
              ) {
                if (k <= 92) {
                  setAreaIntersection("ทับพื้นที่หวงห้าม");
                } else if (k > 92 && k <= 139) {
                  setAreaIntersection("ทับพื้นที่การบินของสนามบิน");
                } else if (k > 139 && k <= 10761) {
                  setAreaIntersection("ทับโรงพยาบาล");
                } else if (k > 10761 && k <= 10811) {
                  setAreaIntersection("ทับสำนักงานข้าราชการ");
                } else if (k > 10811 && k <= 10974) {
                  setAreaIntersection("ทับที่สถานฑูต");
                } else if (k > 10974 && k <= 11062) {
                  setAreaIntersection("ทับที่สถานีตำรวจ");
                } else if (k > 11062 && k <= 11138) {
                  setAreaIntersection("ทับที่ทำการข้าราชการ");
                }
                isIntersecting = true;
                intersectionCount++;
                if (chosenForm === 1) {
                  layerArray[i].setStyle({
                    color: "red",
                    fillColor: "lightpink",
                  });
                }
                break;
              }
            }
          }

          if (chosenForm === 1) {
            if (!isIntersecting) {
              layerArray[i].setStyle({
                color: "green",
                fillColor: "lightgreen",
              });
            }
          }
        }
      }

      if (intersectionCount > 0) {
        setIntersection(true);
        setShowError(true);
      } else {
        setIntersection(false);
        estimateOperationInfo();
      }
    } catch (err) {
      setWrongFormat(true);
      console.log("Error in the Polygon detection : ", err);
      setShowError(true);
    }
  }

  const handleEdit = (e) => {
    setIsEdited([]);
    const layers = e.layers._layers;
    if (tempArrayID[0] !== undefined) {
    }
    setIsEdited(layers);
  };
  const checkoperator = () => {
    const operatorid = sessionStorage.getItem("operator_id");

    if (operatorid === "null" || operatorid === undefined) {
      setShowErroroperation(true);
      setTimeout(() => {
        setShowErroroperation(false);

        // Navigate("/home");
        // window.location.reload(false);
      }, 2000);
    } else {
      const check = AuthServiceV2.NewToken();
      console.log(check);
    }
  };
  useEffect(() => {
    checkoperator();
  }, []);
  useEffect(() => {
    const tempPolygonArrayEdited = [...polygonArray];
    Object.entries(isEdited).forEach(([key, value]) => {
      const index = tempArrayID.findIndex((id) => id === parseInt(key));
      if (value instanceof L.Polygon) {
        tempPolygonArrayEdited[index] = convertPolygonToCoordinates(value);
      } else if (value instanceof L.Circle) {
        tempPolygonArrayEdited[index] = calculateCircleMarkers(value);
      }
    });
    setPolygonArray(tempPolygonArrayEdited);
  }, [isEdited]);

  const handleDelete = (e) => {
    const layers = e.layers;
    const idArray = [];
    clearTimeout(deleteTimerRef.current);
    deleteTimerRef.current = setTimeout(() => {
      layers.eachLayer((layer) => {
        if (layer instanceof L.Polygon) {
          idArray.push(layer._leaflet_id);
        }
        if (layer instanceof L.Circle) {
          idArray.push(layer._leaflet_id);
        }
      });
      setPolygonToDelete(idArray);
    }, 100);
    return () => clearTimeout(deleteTimerRef.current);
  };

  useEffect(() => {
    const indicesToDelete = [];

    polygonToDelete.forEach((id) => {
      const indexToDelete = tempArrayID.findIndex((object) => object === id);
      indicesToDelete.push(indexToDelete);
    });

    const updatedPolygonArray = polygonArray.filter(
      (_, index) => !indicesToDelete.includes(index)
    );
    setPolygonArray(updatedPolygonArray);

    const updatedTempArrayID = tempArrayID.filter(
      (_, index) => !indicesToDelete.includes(index)
    );
    setTempArrayID(updatedTempArrayID);

    const updatedLayerArray = layerArray.filter(
      (_, index) => !indicesToDelete.includes(index)
    );
    setLayerArray(updatedLayerArray);
  }, [polygonToDelete]);

  function timeStringToInt(time) {
    const date = new Date(time);
    return Math.round(date.getTime());
  }

  const shouldDisableStartDate = (date) => {
    // const selectedHour = new Date(date).getHours();
    // console.log(selectedHour - dat);
    return date <= desiredLimit;
  };

  const handleClose = () => {
    setShowSendcoop(false);
    setShowSend(false);
  };

  const handleShow = () => {
    if (chosenForm === 1) {
      if (
        selectedOption.length > 0 &&
        selectedPurpose.length > 0 &&
        chosenHeight > 19 &&
        chosenHeight < 16001 &&
        estimatedInfo[1] !== "REPEATED"
      ) {
        if (estimatedInfo[1] === "READY-DAY") {
          setShowSend(true);
        } else {
          setShowAgreement(true);
          // setShowNoNight(true);
        }
      } else {
        console.log("This !3");
        setShowError(true);
      }
    } else if (chosenForm === 2) {
      if (coopUnit.length > 0 || isCoopFound) {
        setShowAgreement(true);
      } else {
        console.log("This !4");
        setShowError(true);
      }
    } else if (chosenForm === 3) {
      if (filename !== undefined && estimatedInfo[1] !== "REPEATED") {
        if (estimatedInfo[1] === "READY-DAY") {
          setShowSend(true);
        } else {
          setShowAgreement(true);
          // setShowNoNight(true);
        }
      } else {
        console.log("This !5");
        setShowError(true);
      }
    }
  };

  function formattingDate(inputDate) {
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");

    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:00+07:00`;
    return formattedDate;
  }

  function quickSwapElement(arr) {
    console.log(arr.map((subArr) => subArr.map((pair) => [pair[1], pair[0]])));
    return arr.map((subArr) => subArr.map((pair) => [pair[1], pair[0]]));
  }

  function swapElements(arr) {
    const formattedArray = [];

    if (typeof filename === "undefined") {
      formattedArray.push(
        ...arr[0].map((subArr) => subArr.map((pair) => [pair[1], pair[0]]))
      );
    } else {
      for (let j = 0; j < arr.length; j++) {
        if (arr[j][0] !== undefined) {
          const tempFormattedArray = [];
          for (let k = 0; k < arr[j].length; k += 2) {
            tempFormattedArray.push([arr[j][k + 1], arr[j][k]]);
          }
          formattedArray.push(tempFormattedArray);
        }
      }
    }

    return formattedArray;
  }

  const convert = async (kmzfile) => {
    const zip = new JSZip();
    try {
      const kmzData = await zip.loadAsync(kmzfile);
      const kmlData = await kmzData.file("doc.kml").async("string");
      return kmlData;
    } catch (error) {
      console.error("Error converting KMZ to KML:", error);
      return null;
    }
  };
  async function handleFileInputChange(event) {
    const file = event.target.files[0];

    if (file !== undefined) {
      setFilename(event.target.files[0].name);
      if (event.target.files[0].name.includes(".kmz")) {
        const kmlData = await convert(file);
        update(kmlData);
      } else {
        if (file) {
          const reader = new FileReader();

          reader.onload = function (e) {
            const fileContent = e.target.result;

            update(fileContent);
          };
          reader.readAsText(file);
        }
      }
    }
  }

  const kmlRecursiveRead = (feature) => {
    if (feature.geometry.type === "Polygon") {
      const coordinates = feature.geometry.coordinates[0];
      try {
        const kmlRecursiveReadData = coordinates
          .filter(
            (coord) =>
              !isNaN(coord[0]) &&
              !isNaN(coord[1]) &&
              coord[0] !== undefined &&
              coord[1] !== undefined
          )
          .flatMap((coord) => [coord[0], coord[1]]);
        return [kmlRecursiveReadData];
      } catch (err) {
        return null;
      }
    } else if (feature.geometry.type === "GeometryCollection") {
      const arr = feature.geometry.geometries.map((content) => {
        return kmlRecursiveRead({ geometry: content });
      });
      return arr.flat().filter((content) => content !== null);
    } else {
      return null;
    }
  };

  const update = (fileContent) => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(fileContent, "text/xml");
    const geoJsonData = toGeoJSON.kml(xmlDoc);

    if (!geoJsonData) return;
    const positionFileData = geoJsonData.features.map((feature) => {
      return kmlRecursiveRead(feature);
    });
    const arrangedData = positionFileData
      .filter((content) => content !== null)
      .flat();
    const cleanArrangedData = arrangedData.filter(
      (subArray) => subArray.length > 0
    );
    if (cleanArrangedData.length !== 0) {
      const testingP = cleanArrangedData.map((content) => {
        const resultArray = [];
        for (let i = 0; i < content.length; i += 2) {
          if (i + 1 < content.length) {
            resultArray.push([content[i], content[i + 1]]);
          }
        }

        return resultArray;
      });

      console.log(testingP);

      setFileHeight(90);
      setReadFileDone(!readFileDone);
      setSimplifiedKMLPosition(cleanArrangedData);
      setPolygonArray(testingP);
      setMapPosition(testingP[0][0]);
      setWrongFormat(false);
    } else {
      setWrongFormat(true);
      console.log("This !6");
      setShowError(true);
    }
  };

  const handleChangeStart = (newValue) => {
    if (timeStringToInt(newValue) >= timeStringToInt(presentTime)) {
      setDayTimeStart(newValue);
      setDayTimeEnd(dayjs(new Date(timeStringToInt(newValue))).add(3, "hour"));
      // layerArray.forEach((data) => {
      //   data.remove();
      // });
      // setLayerArray([]);
      // setPolygonArray([]);
      const pickedIndex = allReservedArea
        .map((content, index) => {
          if (
            !(
              content.end_time <
                new Date(timeStringToInt(newValue)).getTime() ||
              content.start_time >
                new Date(timeStringToInt(dayTimeEnd)).getTime()
            )
          ) {
            return index;
          }
          return null; // Return null for elements that don't meet the condition
        })
        .filter((index) => index !== null); // Filter out null values

      // console.log(pickedIndex);
      const areaData = pickedIndex.map(
        (content) => allReservedArea[content].operation_area
      );
      console.log(areaData);
      setTimedReservedArea(areaData.flat(1));
    }
  };
  const handleChangeEnd = (newValue) => {
    setDayTimeEnd(newValue);

    const pickedIndex = allReservedArea
      .map((content, index) => {
        if (
          !(
            content.end_time <
              new Date(timeStringToInt(dayTimeStart)).getTime() ||
            content.start_time > new Date(timeStringToInt(newValue)).getTime()
          )
        ) {
          return index;
        }
        return null; // Return null for elements that don't meet the condition
      })
      .filter((index) => index !== null);
    const areaData = pickedIndex.map(
      (content) => allReservedArea[content].operation_area
    );
    setTimedReservedArea(areaData.flat(1));

    layerArray.forEach((data) => {
      data.remove();
    });
    setLayerArray([]);
    setPolygonArray([]);
  };

  const doSearchCooperative = () => {
    findoperation();
    if (searchCoop === true) {
      setSearhCoop(false);
    } else {
      setSearhCoop(true);
    }
  };

  const getOperationAreaData = () => {
    const dataArea = AuthServiceV2.Opearationdata();
    if (dataArea) {
      dataArea.then((response) => {
        console.log("getOperationAreaData", response.data);
        const responseData = response.data;
        const allAreaData = [];

        for (let i = 0; i < responseData.agency_data.length; i++) {
          const TempAreaData = [];
          const agencyArea =
            responseData.agency_data[i].operation_area.Volume3D.outline_polygon
              .vertices;
          for (let j = 0; j < agencyArea.length; j++) {
            const mappedData = agencyArea[j].map((content) => [
              content.Lon,
              content.Lat,
            ]);
            mappedData.push(mappedData[0]);
            TempAreaData.push(mappedData);
          }
          allAreaData.push({
            start_time: new Date(
              responseData.agency_data[i].start_time
            ).getTime(),
            end_time: new Date(responseData.agency_data[i].end_time).getTime(),
            operation_area: TempAreaData,
          });
        }
        for (let i = 0; i < responseData.operator_data.length; i++) {
          const TempAreaData = [];
          if (
            responseData.operator_data[i].operation_status ===
            "หน่วยงานยกเลิกภารกิจ"
          ) {
            setIsEstimatable(false);
          }

          const operatorData =
            responseData.operator_data[i].operation_area.Volume3D
              .outline_polygon.vertices;
          for (let j = 0; j < operatorData.length; j++) {
            const mappedData = operatorData[j].map((content) => [
              content.Lon,
              content.Lat,
            ]);
            mappedData.push(mappedData[0]);
            TempAreaData.push(mappedData);
          }
          allAreaData.push({
            start_time: new Date(
              responseData.operator_data[i].start_time
            ).getTime(),
            end_time: new Date(
              responseData.operator_data[i].end_time
            ).getTime(),
            operation_area: TempAreaData,
          });
        }
        // console.log(allAreaData);
        setAllReservedArea(allAreaData);
      });
    }
  };

  const getDrone = () => {
    const startDate = formattingDate(new Date(dayTimeStart));
    const endDate = formattingDate(new Date(dayTimeEnd));

    const droneAndPilotData = AuthServiceV2.PilotAndDroneData(
      startDate,
      endDate
    );
    // console.log(droneAndPilotData);
    if (!droneAndPilotData) return;

    droneAndPilotData.then((response) => {
      const { dropdown_id, drone_data, pilot_data } = response.data;
      setDropDown_ID(dropdown_id);

      const droneElement = drone_data.map(
        (drone) => `${drone.drone_id}-${drone.brand_model}`
      );
      const purposeElement = drone_data.reduce(
        (acc, drone) => ({ ...acc, [drone.drone_id]: drone.purpose }),
        {}
      );

      const pilotElement = pilot_data.map(
        (pilot) => `${pilot.co_id}-${pilot.pilot_name}`
      );

      setAvailableDrone(droneElement);
      setTempAvailablePurpose(purposeElement);
      setAvailablePilot(pilotElement);
    });
  };

  const estimateOperationInfo = () => {
    const formattedStartDate = formattingDate(new Date(dayTimeStart));
    const formattedEndDate = formattingDate(new Date(dayTimeEnd));

    const positionToPost =
      filename !== undefined && chosenForm === 3
        ? swapElements(simplifiedKMLPosition)
        : chosenForm === 1
        ? swapElements([polygonArray])
        : [];
    console.log("positionToPost ", positionToPost);
    const checkOperation = AuthServiceV2.CheckOperation(
      parseInt(chosenPilot.split("-")[0]),
      availableDroneID,
      selectedPurpose.toString(),
      formattedStartDate,
      formattedEndDate,
      positionToPost,
      chosenHeight,
      2
    );

    if (!checkOperation) return;

    checkOperation
      .then((response) => {
        if (!response) return;

        if (response === "You have operation data in this time period") {
          setEstimatedInfo(["-", "REPEATED"]);
          console.log("This !7");
          setShowError(true);
        } else {
          const {
            data: { ID, status },
          } = response;
          setEstimatedInfo([ID, status]);
          // if (status === "READY-NIGHT") { }
          // handleShow() // Uncomment if needed
        }
      })
      .catch(() => {
        console.log("This !8");
        setShowError(true);
      });
  };

  useEffect(() => {
    if (estimatedInfo.length !== 0) {
      if (estimatedInfo[1] !== "REPEATED") {
        handleShow();
      }
    }
  }, [estimatedInfo]);

  useEffect(() => {
    // console.log(mapRef," ",mapRef.current)
    if (mapRef && mapRef.current) {
      const map = mapRef.current;

      map.flyTo([mapposition[1], mapposition[0]], 16);
    }
  }, [mapposition]);

  const confirmSendInfo = () => {
    let confirmInfo = AuthServiceV2.ComfirmOperation(estimatedInfo[0]);
    if (confirmInfo != null) {
      confirmInfo.then((response) => {});
    }
  };
  const getPDFForNight = async (data_id) => {
    setLoading(true);
    let getPDF = AuthServiceV2.NightFlightForm(data_id);
    if (getPDF != null) {
      getPDF.then((response) => {
        setLoading(false);
        // setShowSend(false);
      });
    }
  };

  useEffect(() => {
    setSideBarToggle(true);
  }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        const { data: thailandData } = await axios.get(
          "https://raw.githubusercontent.com/apisit/thailand.json/master/thailandwithdensity.json"
        );
        setThailandProvince(thailandData);
        const [bangkokPopulationFetched] = await Promise.all([
          axios.get("../../BKK_District.geojson"),
        ]);

        setBangkokPopulation(bangkokPopulationFetched.data);

        const tempAllData = [
          ...bangkokPopulationFetched.data.features.map(
            (feature) => feature.geometry.coordinates[0]
          ),
        ];

        const tempAllDataTest = bangkokPopulationFetched.data.features.map(
          (feature) => ({
            coordinate: feature.geometry.coordinates[0],
            population: feature.properties.DN,
          })
        );
        console.log(tempAllDataTest);
        setProhibitPolygon(tempAllData);
      } catch (error) {
        console.error("Error fetching JSON data:", error);
      }
    }
    fetchData();
    setTimeout(() => {
      getDrone();
      getOperationAreaData();
    }, 1000);
  }, []);

  const styleFunction = (feature) => {
    const population = feature.properties.DN;
    return {
      fillColor: "red", // Set colors based on categories
      color: "transparent",

      fillOpacity:
        population < 1000
          ? 0.1
          : population >= 1000 && population < 2500
          ? 0.2
          : population >= 2500 && population < 5000
          ? 0.3
          : population >= 5000 && population < 7500
          ? 0.4
          : population >= 7500 && population < 10000
          ? 0.5
          : population >= 10000 && population < 15000
          ? 0.6
          : population >= 15000 && population < 20000
          ? 0.7
          : population >= 20000 && population < 25000
          ? 0.8 :
          0.9
          
    };
  };
  // color: "transparent",
  //                     fillColor: "orange",
  //                     fillOpacity: 0.2,

  // useEffect(() => {
  //   async function fetchData() {
  //     try {
  //       // Fetch thailand, PDRArea, and AeroDrome data concurrently
  //       const [{ data: thailandData }, responsePDRArea, responseAeroDrome] =
  //         await Promise.all([
  //           axios.get(
  //             "https://raw.githubusercontent.com/apisit/thailand.json/master/thailandwithdensity.json"
  //           ),
  //           axios.get("../../PDR-AREA.geojson"),
  //           axios.get("../../Aerodrome.geojson"),
  //         ]);

  //       setThailandProvince(thailandData);
  //       setPDRArea(responsePDRArea.data);
  //       setAeroDrome(responseAeroDrome.data);

  //       // Process the PDRArea and AeroDrome data
  //       const tempAllData = [
  //         ...responsePDRArea.data.features.map(
  //           (feature) => feature.geometry.coordinates[0][0]
  //         ),
  //         ...responseAeroDrome.data.features.flatMap((feature) => {
  //           if (!feature.geometry.coordinates[0][0]) return [];
  //           return [feature.geometry.coordinates[0][0]];
  //         }),
  //       ];
  //       setProhibitPolygon(tempAllData);
  //     } catch (error) {
  //       console.error("Error fetching JSON data:", error);
  //     }
  //   }

  //   fetchData();
  // }, []);

  const downloadTxtFile = () => {
    const content = `<?xml version="1.0" encoding="UTF-8"?> 
    <kml xmlns="http://earth.google.com/kml/2.0"> 
        <Document>
            <Placemark> 
                <name>Untitled Polygon</name>
                <styleUrl>#m_ylw-pushpin</styleUrl>
                <Polygon>   
                    <tessellate>1</tessellate>
                    <altitudeMode>absolute</altitudeMode>
                    <outerBoundaryIs>  
                        <LinearRing>
                            <coordinates>
                            106.797494636567,4.653737046372933,0 
                            107.9105999951937,20.18311072920269,0 
                            92.41688357936664,21.16441251608377,0 
                            92.8508903014889,3.853973378567559,0 
                            106.797494636567,4.653737046372933,0 
                            </coordinates>
                        </LinearRing> 
                    </outerBoundaryIs> 
                </Polygon>
                <Style> 
                    <PolyStyle>  
                        <color>#a00000ff</color>
                        <outline>0</outline>
                    </PolyStyle> 
                </Style>
            </Placemark>
        </Document> 
    </kml>`;
    const blob = new Blob([content], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "example.kml";
    a.click();

    URL.revokeObjectURL(url);
  };

  const coop = async () => {
    let check = AuthService.operationco(
      coopUnit,
      numbercoopUnit,
      availableDroneID
    );
    if (check != null) check.then((res) => {});
  };
  const findoperation = () => {
    let check = AuthServiceV2.FindAgencyOperation(coopUnit, numbercoopUnit);
    if (check != null)
      check
        .then((res) => {
          const tempCoopData = [];
          for (
            let i = 0;
            i <
            res.data[0].operation_area.Volume3D.outline_polygon.vertices[0]
              .length;
            i++
          ) {
            tempCoopData.push([
              res.data[0].operation_area.Volume3D.outline_polygon.vertices[0][i]
                .Lat,
              res.data[0].operation_area.Volume3D.outline_polygon.vertices[0][i]
                .Lon,
            ]);
          }
          tempCoopData.push(tempCoopData[0]);

          setCoopArea(tempCoopData);
          setSearchcheck(1);

          setCoopTime([res.data[0].start_time, res.data[0].end_time]);
          if (isCoopFound === true) {
            setIsCoopFound(false);
          }
          setIsCoopFound(true);
        })
        .catch(function (error) {
          if (error.response) {
            setSearchcheck(2);
          }
          setCoopArea([]);
          setIsCoopFound(false);
        });
  };

  const joinoperation = () => {
    let join = AuthServiceV2.JoinOperation(
      coopUnit,
      numbercoopUnit,
      dropdown_id,
      parseInt(chosenPilot.split("-")[0]),
      availableDroneID
    );
    if (join != null)
      join.then((res) => {
        setShowSuccess(true);
      });
  };

  const onEachFeature = (feature, layer) => {
    if (feature.properties && feature.properties.name) {
      layer.bindPopup(feature.properties.name);
    }
  };

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
      if (windowSize[0] < 800) {
        setSideBarToggle(false);
      } else {
        setSideBarToggle(true);
      }
    };
  }, [windowSize]);

  return (
    <div>
      <Modal
        show={showSuccess}
        onHide={() => {
          setEstimatedInfo([]);
          setShowSuccess(false);
          setConfirmSend(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            แจ้งเตือน
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>คุณได้ทำการบันทึกแผนการบินเรียบร้อย</Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              setShowSuccess(false);
            }}
          >
            ปิด
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showSendcoop}
        onHide={() => {
          setEstimatedInfo([]);
          setShowSendcoop(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h3 style={{ color: "orange", letterSpacing: "1px" }}>
              SPECIFIC PLAN
            </h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>โดรนที่ท่านเลือก</h5>
          <h6>
            {selectedOption.join(", ").split("-")[1]}-
            {selectedOption.join(", ").split("-")[2]}
          </h6>
          <h5>รหัสการปฏิบัติการที่ท่านขอเข้าร่วม</h5>
          <h6>
            {coopUnit} - {numbercoopUnit}
          </h6>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          />
          <h5>วันและเวลาเริ่มต้น</h5>
          <h6>{coopTime[0]}</h6>
          <h5>วันและเวลาสิ้นสุด</h5>
          <h6>{coopTime[1]}</h6>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          />
          <h5>ความสูง</h5>
          <h6>{chosenHeight} เมตร</h6>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          />
          <p style={{ fontWeight: "bold" }}>
            คุณสามารถบันทึกแผนในระบบเพื่อแสดงเป็นหลักฐานแก่หน่วยงานที่เกี่ยวข้อง
            และสามารถแสดงเป็นรายงานแผนการบินได้
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            style={{
              height: "50px",
              width: "30%",
              backgroundImage:
                "linear-gradient(97.41deg, #a50104 0%, #ff792b 100%)",
              display: "block",
              margin: "auto",

              borderRadius: "10px",
              fontWeight: "bold",
              fontSize: "20px",
              color: "white",
            }}
            onClick={() => {
              setShowSendcoop(false);
              setEstimatedInfo([]);
            }}
          >
            ยกเลิก
          </button>
          <button
            style={{
              height: "50px",
              width: "30%",
              backgroundColor: "red",
              display: "block",
              margin: "auto",

              borderRadius: "10px",
              backgroundImage: "linear-gradient(97.41deg, #023E8A, #0096C7)",
              fontWeight: "bold",
              fontSize: "20px",
              color: "white",
            }}
            onClick={() => {
              coop();
              handleClose();
            }}
          >
            ขออนุมัติแผน
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showSend}
        onHide={() => {
          setEstimatedInfo([]);
          setShowSend(false);
          setConfirmSend(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {estimatedInfo[1] === "READY-DAY" ? (
              <h3 style={{ color: "green", letterSpacing: "1px" }}>OPEN</h3>
            ) : (
              // <h3 style={{ color: "green", letterSpacing: "1px" }}>OPEN</h3>
              <h3 style={{ color: "purple", letterSpacing: "1px" }}>
                ADVANCE-NIGHT
              </h3>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>โดรนที่ท่านเลือก</h5>
          <h6>
            {selectedOption.join(", ").split("-")[1]}-
            {selectedOption.join(", ").split("-")[2]}
          </h6>
          <h5>วัตถุประสงค์</h5>
          <h6>{selectedPurpose}</h6>
          <h5>วันและเวลาเริ่มต้น</h5>
          <h6>
            {("0" + dayTimeStart["$D"]).slice(-2)}/
            {("0" + (dayTimeStart["$M"] + 1)).slice(-2)}/{dayTimeStart["$y"]} -{" "}
            {("0" + dayTimeStart["$H"]).slice(-2)} :{" "}
            {("0" + dayTimeStart["$m"]).slice(-2)} : 00
          </h6>
          <h5>วันและเวลาสิ้นสุด</h5>
          <h6>
            {("0" + dayTimeEnd["$D"]).slice(-2)}/
            {("0" + (dayTimeEnd["$M"] + 1)).slice(-2)}/{dayTimeEnd["$y"]} -{" "}
            {("0" + dayTimeEnd["$H"]).slice(-2)} :{" "}
            {("0" + dayTimeEnd["$m"]).slice(-2)} : 00
          </h6>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
          <h5>พื้นที่ที่เลือก (ลองจิจูด, ละติจูด)</h5>
          {chosenForm === 1 ? (
            <h6>{polygonArray.toString().substring(0, 54)}...</h6>
          ) : null}
          {chosenForm === 2 ? (
            <h6>{coopArea.toString().substring(0, 54)}...</h6>
          ) : null}
          {chosenForm === 3 && filename !== undefined ? (
            <h6>{simplifiedKMLPosition.toString().substring(0, 54)}...</h6>
          ) : null}

          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
          <h5>ความสูง</h5>
          {chosenForm === 3 && filename !== undefined ? (
            <h6>{fileHeight} เมตร</h6>
          ) : (
            <h6>{chosenHeight} เมตร</h6>
          )}

          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
          <p style={{ fontWeight: "bold" }}>
            {" "}
            คุณสามารถบันทึกแผนในระบบเพื่อแสดงเป็นหลักฐานแก่หน่วยงานที่เกี่ยวข้อง
            และสามารถแสดงเป็นรายงานแผนการบินได้
          </p>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
          <div style={{ display: "flex" }}>
            <input
              style={{ width: "25px", height: "25px", margin: "auto 0px" }}
              type="checkbox"
              onChange={() => {
                if (confirmSend === false) {
                  setConfirmSend(true);
                } else {
                  setConfirmSend(false);
                }
              }}
            />
            <h4
              style={{
                fontWeight: "300",
                whiteSpace: "nowrap",
                margin: "auto 0px auto 10px",
              }}
            >
              คุณยอมรับกับข้อตกลงหรือไม่
            </h4>
          </div>
          {estimatedInfo[1] === "READY-DAY" ? null : (
            <button
              style={{
                height: "35px",
                width: "90%",
                backgroundImage: "linear-gradient(97.41deg, #023E8A, #0096C7)",
                display: "block",
                margin: "auto",

                borderRadius: "10px",
                fontWeight: "bold",
                fontSize: "20px",
                color: "white",
              }}
              onClick={() => {
                getPDFForNight(estimatedInfo[0]);
                console.log("This", estimatedInfo[0]);
              }}
            >
              ดาวน์โหลดเอกสารการส่งแผนการบิน
            </button>
          )}
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
        </Modal.Body>
        <Modal.Footer>
          <button
            style={{
              height: "50px",
              width: "30%",
              backgroundImage:
                "linear-gradient(97.41deg, #a50104 0%, #ff792b 100%)",
              display: "block",
              margin: "auto",

              borderRadius: "10px",
              fontWeight: "bold",
              fontSize: "20px",
              color: "white",
            }}
            onClick={() => {
              setEstimatedInfo([]);
              handleClose();
              setConfirmSend(false);
            }}
          >
            ยกเลิก
          </button>
          {estimatedInfo[1] === "READY-DAY" ? (
            <button
              style={{
                height: "50px",
                width: "40%",
                backgroundColor: "red",
                display: "block",
                margin: "auto",

                borderRadius: "10px",
                backgroundImage: "linear-gradient(97.41deg, #023E8A, #0096C7)",
                fontWeight: "bold",
                fontSize: "20px",
                color: "white",
              }}
              onClick={() => {
                if (confirmSend === true) {
                  if (chosenForm !== 2) {
                    confirmSendInfo();
                    handleClose();
                    setShowSuccess(true);
                    // window.location.reload(false);
                  } else {
                    joinoperation();
                    handleClose();
                    setShowSuccess(true);
                    // window.location.reload(false);
                  }
                }
              }}
            >
              บันทึกแผน
            </button>
          ) : (
            <button
              style={{
                height: "50px",
                width: "50%",
                backgroundColor: "red",
                display: "block",
                margin: "auto",

                borderRadius: "10px",
                backgroundImage: "linear-gradient(97.41deg, #023E8A, #0096C7)",
                fontWeight: "bold",
                fontSize: "20px",
                color: "white",
              }}
              onClick={() => {
                if (confirmSend === true) {
                  if (chosenForm !== 2) {
                    // getPDFForNight(estimatedInfo[0])
                    confirmSendInfo();
                    handleClose();
                    setShowSuccess(true);
                    // window.location.reload(false);
                  } else {
                    joinoperation();
                    handleClose();
                    setShowSuccess(true);
                    // window.location.reload(false);
                  }
                }
              }}
            >
              ส่งแบบร่างขออนุญาติ
            </button>
          )}
        </Modal.Footer>
      </Modal>
      <Modal
        show={showError}
        onHide={() => {
          setShowError(false);
          setEstimatedInfo([]);
          setAreaIntersection("");
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h3 style={{ color: "red", letterSpacing: "1px" }}>โปรดตรวจสอบ</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedOption.length === 0 ? (
            <h4 style={{ color: "red" }}>- กรุณาเลือกโดรน</h4>
          ) : null}
          {selectedPurpose.length === 0 ? (
            <h4 style={{ color: "red" }}>- กรุณาเลือกวัตถุประสงค์</h4>
          ) : null}
          {polygonArray.length === 0 && chosenForm === 1 ? (
            <h4 style={{ color: "red" }}>- กรุณาเลือกพื้นที่</h4>
          ) : null}
          {intersection === true ? (
            <h4 style={{ color: "red" }}>
              - กรุณาเลือก พื้นที่ที่ไม่ทับกัน {areaIntersection}
            </h4>
          ) : null}
          {chosenHeight <= 20 ? (
            <h4 style={{ color: "red" }}>- ต้องมีความสูงมากกว่า 20 เมตร</h4>
          ) : null}
          {chosenHeight >= 16000 ? (
            <h4 style={{ color: "red" }}>- ต้องมีความสูงไม่เกิน 16000 เมตร</h4>
          ) : null}
          {coopUnit.length === 0 && chosenForm === 2 ? (
            <h4 style={{ color: "red" }}>
              - กรุณากรอกรหัสการร่วมมือระหว่างหน่วยงาน
            </h4>
          ) : null}
          {isCoopFound === false && chosenForm === 2 ? (
            <h4 style={{ color: "red" }}>- รหัสหน่วยงานไม่ถูกต้อง</h4>
          ) : null}
          {filename === undefined && chosenForm === 3 ? (
            <h4 style={{ color: "red" }}>- โปรดเพิ่มไฟล์ kml, kmz</h4>
          ) : null}
          {estimatedInfo[1] === "REPEATED" ? (
            <h4 style={{ color: "red" }}>- คุณมีการปฏิบัติการในช่วงเวลานี้</h4>
          ) : null}
          {wrongFormat === true && chosenForm === 3 ? (
            <>
              <h4 style={{ color: "red" }}>
                {wrongFormat}- กรุณาตรวจสอบรูปแบบของไฟล์ KML/KMZ
              </h4>
              <button onClick={downloadTxtFile}>ดาวน์โหลดไฟล์ตัวอย่าง</button>
            </>
          ) : null}
          {/* <h4 style={{ color: "red" }}>พื้นที่ของคุณทับซ้อนกับพื้นที่ห้ามบิน</h4> */}
        </Modal.Body>
      </Modal>

      <Modal
        show={loading}
        onHide={() => setLoading(false)}
        aria-labelledby="contained-modal-title-vcenter"
        size="sm"
        centered
      >
        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span className="spinner-border spinner-border"></span>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showErroroperation}
        onHide={() => setShowErroroperation(false)}
        aria-labelledby="contained-modal-title-vcenter"
        size="sm"
        centered
      >
        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            กรุณาขึ้นทะเบียนผู้ฎิบัติการก่อนค่ะ
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showNoNight}
        onHide={() => setShowNoNight(false)}
        aria-labelledby="contained-modal-title-vcenter"
        size="sm"
        centered
      >
        <Modal.Body>
          <h4 style={{ color: "red" }}>กรุณาเลือกเวลาการบิน 7:00 - 17:00</h4>
        </Modal.Body>
      </Modal>
      <Modal
        show={showAgreement}
        onHide={() => {
          setShowAgreement(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h3>ข้อตกลงก่อนทำการบิน</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <table
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                width: "100%",
                fontSize: "20px",
              }}
            >
              <thead>
                <tr>
                  <th className="table-space">เนื้อหา</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: "15px" }}>
                {agreementContent.map((content, index) => {
                  // Check if the current index is within the desired range
                  if (
                    (agreementPage - 1) * 5 <= index &&
                    index < agreementPage * 5
                  ) {
                    return (
                      <tr
                        key={index}
                        style={index % 2 === 0 ? { background: "#f2f2f2" } : {}}
                      >
                        <td
                          className="table-space"
                          style={{
                            width: "75%",
                            margin: "0px",
                            textAlign: "left",
                            paddingLeft: "25px",
                          }}
                        >
                          <p style={{ fontSize: "20px" }}>{content.text}</p>
                        </td>
                      </tr>
                    );
                  } else {
                    // It's important to return 'null' if you don't want anything rendered.
                    return null;
                  }
                })}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            style={{
              height: "50px",
              width: "30%",
              backgroundImage:
                "linear-gradient(97.41deg, #a50104 0%, #ff792b 100%)",
              display: "block",
              margin: "auto",

              borderRadius: "10px",
              fontWeight: "bold",
              fontSize: "20px",
              color: "white",
            }}
            onClick={() => {
              if (agreementPage > 1) {
                setAgreementPage(agreementPage - 1);
              } else {
                setShowAgreement(false);
                setShowSend(true);
              }
            }}
          >
            ย้อนกลับ
          </button>
          <button
            style={{
              height: "50px",
              width: "30%",
              backgroundColor: "red",
              display: "block",
              margin: "auto",

              borderRadius: "10px",
              backgroundImage: "linear-gradient(97.41deg, #023E8A, #0096C7)",
              fontWeight: "bold",
              fontSize: "20px",
              color: "white",
            }}
            onClick={() => {
              if (agreementPage > 6) {
                setShowAgreement(false);
                setAgreementPage(1);
                setShowSend(true);
              } else {
                setAgreementPage(agreementPage + 1);
              }
            }}
          >
            หน้าต่อไป
          </button>
        </Modal.Footer>
      </Modal>
      <div className="menu-container">
        <div style={{ height: "100%", width: "100%" }}>
          <button
            style={{
              position: "absolute",
              top: "275px",
              right: "10px",
              zIndex: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "35px",
              width: "35px",
              backgroundColor: "white",
              borderWidth: "1px",
              borderColor: "grey",
              color: "black",
            }}
            className="btn btn-primary"
            onClick={showMyLocation}
          >
            <GoLocation />
          </button>
          <MapContainer
            center={[13.101029105523143, 100.92994760607247]}
            zoom={13}
            keyboard={true}
            style={{ width: "100%", height: "100vh", zIndex: 1 }}
            ref={mapRef}
          >
            {thailandProvince && (
              <GeoJSON
                data={thailandProvince}
                style={{
                  color: null,
                  fillColor: "white",
                  fillOpacity: 0,
                }}
                // onEachFeature={onEachFeature}
              />
            )}
            {/* <AttributionControl position="topright"></AttributionControl> */}
            <LayersControl position="bottomright">
              <LayersControl.BaseLayer name="Google Map">
                <TileLayer
                  style={{ zIndex: 2 }}
                  url="http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer checked name="OpenStreet Map">
                <TileLayer
                  style={{ zIndex: 2 }}
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name="OpenToPo Map">
                <TileLayer
                  style={{ zIndex: 2 }}
                  url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name="ThunderForest Map">
                <TileLayer
                  style={{ zIndex: 2 }}
                  url="https://tile.thunderforest.com/landscape/{z}/{x}/{y}.png
"
                />
              </LayersControl.BaseLayer>
              <LayersControl.Overlay checked name="Aerodome area">
                {bangkokPopulation && (
                  <GeoJSON
                    data={bangkokPopulation}
                    style={styleFunction}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay>
              {/* <LayersControl.Overlay checked name="Flight prohibitation area">
                {PDRArea && (
                  <GeoJSON
                    data={PDRArea}
                    style={{
                      color: "red",
                      fillColor: "red",
                      fillOpacity: 0.5,
                    }}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay>
              <LayersControl.Overlay checked name="Hospital area">
                {hospital && (
                  <GeoJSON
                    data={hospital}
                    style={{
                      color: "purple",
                      fillColor: "purple",
                      fillOpacity: 0.5,
                    }}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay>
              <LayersControl.Overlay checked name="Goverment Office area">
                {govOffice && (
                  <GeoJSON
                    data={govOffice}
                    style={{
                      color: "blue",
                      fillColor: "blue",
                      fillOpacity: 0.5,
                    }}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay>
              <LayersControl.Overlay checked name="Embassy area">
                {embassy && (
                  <GeoJSON
                    data={embassy}
                    style={{
                      color: "yellow",
                      fillColor: "yellow",
                      fillOpacity: 0.5,
                    }}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay>
              <LayersControl.Overlay checked name="Police department area">
                {policeDepartment && (
                  <GeoJSON
                    data={policeDepartment}
                    style={{
                      color: "green",
                      fillColor: "green",
                      fillOpacity: 0.5,
                    }}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay>
              <LayersControl.Overlay checked name="Thai Goverment area">
                {thaiGov && (
                  <GeoJSON
                    data={thaiGov}
                    style={{
                      color: "red",
                      fillColor: "red",
                      fillOpacity: 1,
                    }}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay> */}
            </LayersControl>
            {coopArea && chosenForm === 2 ? (
              <Polygon
                pathOptions={{
                  color: "orange",
                  fillColor: "yellow",
                  fillOpacity: 0.6,
                }}
                positions={coopArea}
              />
            ) : null}
            {simplifiedKMLPosition.length > 0 && chosenForm === 3 ? (
              <Polygon
                pathOptions={{
                  color: "orange",
                  fillColor: "yellow",
                  fillOpacity: 0.6,
                }}
                positions={swapElements(simplifiedKMLPosition)}
              />
            ) : null}
            {timedReservedArea.length > 0 ? (
              <Polygon
                pathOptions={{
                  color: "orange",
                  fillColor: "yellow",
                  fillOpacity: 0.6,
                }}
                positions={quickSwapElement(timedReservedArea)}
              />
            ) : null}
            {chosenForm === 2 || chosenForm === 3 ? null : (
              <FeatureGroup>
                <EditControl
                  position="topright"
                  onCreated={handleCreation}
                  onEdited={handleEdit}
                  onDeleted={handleDelete}
                  draw={{
                    polyline: false,
                    polygon:
                      polygonArray.length === 0
                        ? {
                            allowIntersection: false,
                            showArea: true,
                            showLength: true,
                            metric: ["km", "m"],
                            shapeOptions: {
                              color: "green",
                              fillColor: "lightgreen",
                              fillOpacity: 0.6,
                            },
                          }
                        : false,
                    rectangle: false,
                    circle:
                      polygonArray.length === 0
                        ? {
                            shapeOptions: {
                              color: "green",
                              fillColor: "lightgreen",
                              fillOpacity: 0.6,
                            },
                          }
                        : false,
                    marker: false,
                    circlemarker: false,
                  }}
                  edit={{
                    delete: true,
                    edit: true,
                  }}
                />
              </FeatureGroup>
            )}
          </MapContainer>
        </div>
      </div>
    </div>
  );
}

export default LeafletLab;
